import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import NotificationJobsContainer from '../containers/NotificationJobs';
import NotifierContainer from '../containers/Notifier';

import ViewNotificationJobDialog from '../components/ViewNotificationJobDialog';
import DcNotificationJobDialog from '../components/DcNotificationJobDialog';
import TestNotificationJobDialog from '../components/TestNotificationJobDialog';
import ConfirmNotifierHaltDialog from '../components/ConfirmNotifierHaltDialog';
import ConfirmNotifierRunNowDialog from '../components/ConfirmNotifierRunNowDialog';
import DeleteIcon from '@material-ui/icons/Delete';
import CheckIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { Link } from 'react-router-dom';

import { getSharedStyles } from '../themes';
import EnhancedTableHead from '../components/EnhancedTableHead';
import { sortTable } from '../libs/utility';
const styles = (theme) => ({
	...getSharedStyles(theme),
	sectionHeader: {
		textTransform: 'uppercase',
		fontSize: 14,
		color: '#777',
		fontWeight: 900,
		letterSpacing: 2,
		marginTop: 30,
		marginBottom: 10,
	},
	testBody: {
		border: '1px solid #ddd',
		padding: 10,
	},
	bodyPre: {
		whiteSpace: 'pre-wrap',
	},
	dialogPaper: {
		maxWidth: 1000,
		overflow: 'scroll',
	},
	row: {
		cursor: 'pointer',
	},
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	controlButton: {
		borderRadius: 100,
		textDecoration: 'none',
		margin: '0px 10px',
	},
	notifierStatusGood: {
		color: '#4CAF50',
		width: 20,
		height: 20,
		verticalAlign: 'middle',
		paddingRight: 5,
	},
	notifierStatusHalted: {
		color: '#FFC107',
		width: 20,
		height: 20,
		verticalAlign: 'middle',
		paddingRight: 5,
	},
	notifierStatus: {
		fontSize: 18,
	},
	table: {
		width: '100%',
		tableLayout: 'auto',
	},
});

const columnData = [
	{ id: 'name', numeric: false, label: 'Name' },
	{ id: 'formulaType', numeric: false, label: 'Fuel Type' },
	{ id: 'stations', numeric: false, label: 'Stations' },
	{ id: 'emails', numeric: false, label: 'Emails' },
	{ id: '', align: 'center', label: 'Actions' },
];

class NotificationJobs extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isTestDialogOpen: false,
			testJobResult: {},
			isViewDialogOpen: false,
			viewNotificationJob: undefined,
			isDcDialogOpen: false,
			isHaltDialogOpen: false,
			isRunNowDialogOpen: false,
			dcNotificationJob: undefined,
			order: 'asc',
			orderBy: 'name',
		};

		//this._handleClick = this._handleClick.bind(this);
		this.handleEdit = this.handleEdit.bind(this);
		this.handleTest = this.handleTest.bind(this);
		this.handleTestDialogClose = this.handleTestDialogClose.bind(this);

		this.handleRowClick = this.handleRowClick.bind(this);
		this.handleDeleteConfirm = this.handleDeleteConfirm.bind(this);
		this.handleCloseViewDialog = this.handleCloseViewDialog.bind(this);
		this.handleCloseDcDialog = this.handleCloseDcDialog.bind(this);

		this.handleOpenHaltDialog = this.handleOpenHaltDialog.bind(this);
		this.handleCloseHaltDialog = this.handleCloseHaltDialog.bind(this);
		this.handleResumeNotifier = this.handleResumeNotifier.bind(this);

		this.handleOpenRunNowDialog = this.handleOpenRunNowDialog.bind(this);
		this.handleCloseRunNowDialog = this.handleCloseRunNowDialog.bind(this);
	}

	componentDidMount() {
		if (!this.props.notificationJobs.length) {
			this.props.search();
		}
		if (!this.props.notifierStatus) {
			this.props.getNotifierStatus();
		}
	}

	handleTestDialogClose() {
		this.setState({ isTestDialogOpen: false });
	}

	handleEdit(notificationJobId) {
		this.props.history.push(`/notificationJob/update/${notificationJobId}`);
	}

	handleTest(notificationJobId) {
		this.props.testNotificationJob({
			params: {
				notificationJobIds: [notificationJobId],
			},
			callback: (err, r) => {
				if (err) {
					return;
				}

				const jobResult = _.get(r, ['jobResults', 0]);
				if (!jobResult) {
					console.warn('warning');
					return;
				}

				this.setState({
					isTestDialogOpen: true,
					testJobResult: jobResult,
				});
			},
		});
	}

	handleResumeNotifier() {
		this.props.resumeNotifier();
	}

	handleRowClick(id) {
		const { notificationJobs } = this.props;
		const viewNotificationJob = _.find(notificationJobs, { notificationJobId: id });
		this.setState({
			viewNotificationJob,
			isViewDialogOpen: true,
		});
	}

	handleOpenHaltDialog() {
		this.setState({ isHaltDialogOpen: true });
	}

	handleCloseHaltDialog() {
		this.setState({ isHaltDialogOpen: false });
	}

	handleOpenRunNowDialog() {
		this.setState({ isRunNowDialogOpen: true });
	}

	handleCloseRunNowDialog() {
		this.setState({ isRunNowDialogOpen: false });
	}

	handleDeleteConfirm(id) {
		const { notificationJobs } = this.props;
		const dcNotificationJob = _.find(notificationJobs, { notificationJobId: id });
		this.setState({
			dcNotificationJob,
			isDcDialogOpen: true,
		});
	}

	handleCloseViewDialog() {
		this.setState({ isViewDialogOpen: false, viewNotificationJob: undefined });
	}

	handleCloseDcDialog() {
		this.setState({ isDcDialogOpen: false, dcNotificationJob: undefined });
	}

	handleRequestSort = (property) => {
		const orderBy = property;
		let order = 'desc';
		if (this.state.orderBy === property && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order, orderBy });
	};

	render() {
		const { classes, notificationJobs, authUser, stationMap, notifierStatus, userMap } = this.props;

		if (!authUser) {
			return null;
		}

		const canViewPricingNotifications = _.get(authUser, [
			'permissions',
			'canViewPricingNotifications',
		]);
		if (!canViewPricingNotifications) {
			return <div>INVALID PERMISSIONS! GET OUTTA HERE!</div>;
		}

		if (!notificationJobs || !stationMap || !notifierStatus) {
			return null;
		}
		const { order, orderBy } = this.state;

		const canMakeUpdates = _.get(authUser, ['permissions', 'canMakeUpdates']);
		const canEditPricingNotifications = _.get(authUser, [
			'permissions',
			'canEditPricingNotifications',
		]);
		let selectedId;
		if (this.state.isDcDialogOpen) {
			selectedId = this.state.dcNotificationJob.notificationJobId;
		}

		let data = notificationJobs.map((s) => {
			/** @namespace s.emails **/
			/** @namespace s.stationIds **/
			/** @namespace s.notificationJobId **/
			const stationIds = s.stationIds || [];
			const stations = stationIds
				.map((stationId) => {
					const station = stationMap[stationId];
					return station ? `${station.number} - ${station.name}` : null;
				})
				.filter(Boolean);

			const emails = s.emails || [];
			return {
				id: s.notificationJobId,
				isSelected: s.notificationJobId === selectedId,
				name: s.name,
				fuelType: s.formulaType === 'biodiesel' ? 'Biodiesel' : 'E85',
				stations: stations,
				emails: emails,
			};
		});
		data = sortTable({ data, order, orderBy });

		/** @typedef string notifierStatus.currentStatus **/
		/** @namespace notificationStatus.currentStatus **/
		const isStopped = notifierStatus.currentStatus === 'stopped';
		let stoppedBy, reason;
		if (isStopped) {
			const user = userMap[notifierStatus.createdByUserId];
			stoppedBy = `${user.firstName} ${user.lastName}`;
			reason = notifierStatus.reason;
		}

		return (
			<div style={{ width: '100%' }}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						{canMakeUpdates && (
							<div style={{ textAlign: 'left', marginBottom: 30 }}>
								<Grid container spacing={3}>
									<Grid item xs={6}>
										<Typography variant="h5" align="left" gutterBottom>
											Notifier Controls
										</Typography>
									</Grid>
								</Grid>
								<Paper className={classes.paper}>
									{!isStopped && (
										<p className={classes.notifierStatus}>
											<CheckIcon className={classes.notifierStatusGood} />
											Notifier is running normally
										</p>
									)}

									{isStopped && (
										<p className={classes.notifierStatus}>
											<WarningIcon className={classes.notifierStatusHalted} />
											Notifier is currently stopped
											<p>Stopped by {stoppedBy}</p>
											<p>Reason : {reason}</p>
										</p>
									)}

									<div>
										{!isStopped && (
											<Button
												variant="contained"
												className={classes.controlButton}
												onClick={this.handleOpenHaltDialog}
												disabled={!canEditPricingNotifications}
											>
												HALT NOTIFIER
											</Button>
										)}

										{isStopped && (
											<Button
												variant="contained"
												color="primary"
												className={classes.controlButton}
												onClick={this.handleResumeNotifier}
												disabled={!canEditPricingNotifications}
											>
												RESUME NOTIFIER
											</Button>
										)}

										<Button
											variant="contained"
											className={classes.controlButton}
											onClick={this.handleOpenRunNowDialog}
											disabled={!canEditPricingNotifications}
										>
											RUN NOTIFIER
										</Button>
									</div>
									{!canEditPricingNotifications && (
										<div style={{ marginTop: 15, color: '#999', fontStyle: 'italic' }}>
											You don&apos;t have permission to run or modify any pricing notifications
										</div>
									)}
								</Paper>
							</div>
						)}

						<div>
							<Grid container spacing={3}>
								<Grid item xs={6}>
									<Typography variant="h5" align="left" gutterBottom>
										Notification Jobs
									</Typography>
								</Grid>
								{canMakeUpdates && (
									<Grid item xs={6} style={{ textAlign: 'right' }}>
										{canEditPricingNotifications ? (
											<Link to="/notificationJob/add" style={{ textDecoration: 'none' }}>
												<Button
													variant="contained"
													color="primary"
													style={{ borderRadius: 100, textDecoration: 'none', marginBottom: 10 }}
													disabled={!canEditPricingNotifications}
												>
													ADD JOB
												</Button>
											</Link>
										) : (
											<Button
												variant="contained"
												color="primary"
												style={{ borderRadius: 100, textDecoration: 'none', marginBottom: 10 }}
												disabled
											>
												ADD JOB
											</Button>
										)}
									</Grid>
								)}
							</Grid>

							<Paper className={classes.paper}>
								<Table stickyHeader size="small" className={classes.table}>
									<EnhancedTableHead
										columnData={columnData}
										order={order}
										orderBy={orderBy}
										onRequestSort={this.handleRequestSort}
									/>
									<TableBody>
										{data.map((n) => {
											return (
												<TableRow
													hover
													className={classes.row}
													style={{ backgroundColor: n.isSelected ? '#ef9a9a' : undefined }}
													key={n.id}
												>
													<TableCell onClick={() => this.handleRowClick(n.id)}>{n.name}</TableCell>
													<TableCell onClick={() => this.handleRowClick(n.id)}>
														{n.fuelType}
													</TableCell>
													<TableCell onClick={() => this.handleRowClick(n.id)}>
														{n.stations && n.stations.length > 0 ? (
															<div style={{ whiteSpace: 'pre-line' }}>{n.stations.join('\n')}</div>
														) : (
															'No stations'
														)}
													</TableCell>
													<TableCell onClick={() => this.handleRowClick(n.id)}>
														{n.emails && n.emails.length > 0 ? (
															<div style={{ whiteSpace: 'pre-line' }}>{n.emails.join('\n')}</div>
														) : (
															'No emails'
														)}
													</TableCell>
													<TableCell align={'center'}>
														<Button
															className={classes.button}
															onClick={() => this.handleTest(n.id)}
														>
															Check
														</Button>
														{canMakeUpdates && (
															<div style={{ display: 'inline-block' }}>
																<Button
																	className={classes.button}
																	onClick={() => this.handleEdit(n.id)}
																	disabled={!canEditPricingNotifications}
																>
																	Edit
																</Button>

																<IconButton
																	className={classes.button}
																	onClick={() => this.handleDeleteConfirm(n.id)}
																	disabled={!canEditPricingNotifications}
																>
																	<DeleteIcon />
																</IconButton>
															</div>
														)}
													</TableCell>
												</TableRow>
											);
										})}
									</TableBody>
								</Table>
								<ViewNotificationJobDialog
									onClose={this.handleCloseViewDialog}
									stationMap={stationMap}
									authUser={authUser}
									notificationJob={this.state.viewNotificationJob}
									open={this.state.isViewDialogOpen}
									history={this.props.history}
								/>

								<DcNotificationJobDialog
									onClose={this.handleCloseDcDialog}
									notificationJob={this.state.dcNotificationJob}
									stationMap={stationMap}
									open={this.state.isDcDialogOpen}
									history={this.props.history}
									removeNotificationJob={this.props.removeNotificationJob}
								/>

								<ConfirmNotifierHaltDialog
									onClose={this.handleCloseHaltDialog}
									open={this.state.isHaltDialogOpen}
									history={this.props.history}
									haltNotifier={this.props.haltNotifier}
								/>

								<ConfirmNotifierRunNowDialog
									onClose={this.handleCloseRunNowDialog}
									open={this.state.isRunNowDialogOpen}
									history={this.props.history}
									runNotifier={this.props.runNotifier}
								/>

								<TestNotificationJobDialog
									onClose={this.handleTestDialogClose}
									open={this.state.isTestDialogOpen}
									notificationJob={this.state.dcNotificationJob}
									stationMap={stationMap}
									jobResult={this.state.testJobResult}
								/>
							</Paper>
						</div>
					</Grid>
				</Grid>
			</div>
		);
	}
}

NotificationJobs.propTypes = {
	classes: PropTypes.object.isRequired,
	search: PropTypes.func.isRequired,
	testNotificationJob: PropTypes.func.isRequired,
	removeNotificationJob: PropTypes.func.isRequired,

	haltNotifier: PropTypes.func.isRequired,
	runNotifier: PropTypes.func.isRequired,
	resumeNotifier: PropTypes.func.isRequired,
	getNotifierStatus: PropTypes.func.isRequired,
	notifierStatus: PropTypes.object,

	notificationJobs: PropTypes.array,
	stationMap: PropTypes.object,
	userMap: PropTypes.object,
	order: PropTypes.string,
	orderBy: PropTypes.string,
	history: PropTypes.object,
	authUser: PropTypes.object,
};

export default _.flow([withStyles(styles), NotificationJobsContainer, NotifierContainer])(
	NotificationJobs
);
